<template lang='pug'>
	.cheers(id='home')
		v-e24-nav-bar
		headerResources(:srcImage='img', :tall="tall", h1="Cheers Registration Instructions")
		contentCheers
		v-e24-footer(:build="build")
</template>

<script>
import headerResources from '@/commonSite/header.vue'
import contentCheers from '@/components/resources/content-cheers.vue'
import imageHeader from '@/img/faq-header.jpg'
import readBuild from '../util/readBuild'

export default {
	name: 'cheers-reg',
	components: {
		headerResources,
		contentCheers
	},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	},
	data: function () {
		return {
			build: '',
			img: imageHeader,
			tall: 90
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/CheersReg.vue